import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ROLES_FEATURE_KEY } from './keys';
import { rolesReducer } from './reducers/roles.reducer';
import { RolesEffects } from './effects/roles.effects';
import { RolesRoleBridge } from './bridges/roles_role.bridge';

export function provideRolesStore(): EnvironmentProviders[] {
    return [provideState(ROLES_FEATURE_KEY, rolesReducer), provideEffects(RolesEffects, RolesRoleBridge)];
}
